module.exports = __webpack_public_path__ + "static/media/PF_Din_Mono_W01_Regular.7a562bbf.woff";